import { render, staticRenderFns } from "./CardConstitution.vue?vue&type=template&id=70c51730&"
import script from "./CardConstitution.vue?vue&type=script&lang=js&"
export * from "./CardConstitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports